<template>
    <div>
        <Head>
            <title>Become a Dealer</title>
            <meta name="description" :content="metaDescription" />
            <meta name="keywords" :content="metaKeywords" />
        </Head>
        <Cms
            content-prop="cmsContent"
            v-model="builderData"
            model="content-section"
            :search-params="searchParams"
            driver="builder"
            :components="getRegisteredComponents()"
            is-section
        />
    </div>
</template>
<script lang="ts" setup>
    import Cms from "@/components/Cms.vue";
    import { registeredComponents } from "../../become-a-dealer-init-builder.ts";
    import { computed, ref } from "vue";
    import { Head } from "@inertiajs/vue3";
    const getRegisteredComponents = () => registeredComponents;
    let searchParams = computed(()=>{
        return {
            'data.pageUrl.$eq': 'become-a-dealer'
        }
    })

    let props = defineProps({
        cmsContent: {
            type: Object,
            default: () => ({
                data: {
                    pageName: null,
                    metaDescription: "",
                    metaKeywords: ""
                }
            })
        }
    })

    let builderData = ref({
        pageName: ""
    });

    let pageName = computed(()=>{
        return props.cmsContent?.data?.pageName ?? builderData.value?.pageName;
    })

    let metaDescription = computed(()=>{
        return props.cmsContent?.data?.metaDescription ?? builderData.value?.metaDescription;
    })
    let metaKeywords = computed(()=>{
        return props.cmsContent?.data?.metaKeywords ?? builderData.value?.metaKeywords;
    })
</script>